import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [showRdv, setShowRdv] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 4000);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div style={styles.page}>
      {/* === Fond aurora mesh === */}
      <div style={styles.auroraLayer1} />
      <div style={styles.auroraLayer2} />
      <div style={styles.auroraLayer3} />
      <div style={styles.noiseOverlay} />

      {/* === Grille décorative === */}
      <div style={styles.gridOverlay} />

      {/* === Bouton retour === */}
      <motion.button
        onClick={() => navigate("/education", { replace: true })}
        whileHover={{ scale: 1.04, x: -3 }}
        whileTap={{ scale: 0.97 }}
        style={styles.backButton}
      >
        <span style={styles.backArrow}>←</span>
        <span>Retour</span>
      </motion.button>

      {/* === Layout deux colonnes === */}
      <div style={styles.layout}>

        {/* Colonne gauche — infos */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          style={styles.leftCol}
        >
          <div style={styles.eyebrow}>
            <span style={styles.eyebrowDot} />
            HDC Éducation
          </div>

          <h1 style={styles.bigTitle}>
            Parlons de<br />
            <span style={styles.bigTitleAccent}>votre projet.</span>
          </h1>

          <p style={styles.leftSubtitle}>
            Notre équipe est disponible pour échanger avec vous — que ce soit
            pour un accompagnement scolaire, un partenariat ou une simple question.
          </p>

          <div style={styles.contactInfoList}>
            {[
              { icon: "📍", label: "Localisation", value: "France & Afrique de l’Ouest" },
              { icon: "⏱", label: "Réponse", value: "Sous 24h ouvrées" },
              { icon: "📅", label: "RDV", value: "Créneau 30 min disponible" },
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 + i * 0.1, duration: 0.5 }}
                style={styles.infoCard}
              >
                <span style={styles.infoIcon}>{item.icon}</span>
                <div>
                  <div style={styles.infoLabel}>{item.label}</div>
                  <div style={styles.infoValue}>{item.value}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Colonne droite — formulaire */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
          style={styles.card}
        >
          {/* Effet bord lumineux */}
          <div style={styles.cardGlowBorder} />

          <div style={styles.cardInner}>
            <div style={styles.cardHeader}>
              <div style={styles.cardIcon}>✉️</div>
              <div>
                <h2 style={styles.cardTitle}>Envoyez-nous un message</h2>
                <p style={styles.cardSubtitle}>
                  Réponse garantie sous 24h ouvrées
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmit} style={styles.form}>
              <FloatInput
                name="name"
                label="Nom complet"
                type="text"
                value={form.name}
                onChange={handleChange}
              />
              <FloatInput
                name="email"
                label="Adresse e-mail"
                type="email"
                value={form.email}
                onChange={handleChange}
              />
              <FloatTextarea
                name="message"
                label="Votre message"
                value={form.message}
                onChange={handleChange}
              />

              <motion.button
                type="submit"
                style={styles.primaryButton}
                whileHover={{ scale: 1.02, boxShadow: "0 20px 60px rgba(99,102,241,0.45)" }}
                whileTap={{ scale: 0.98 }}
              >
                <span>Envoyer le message</span>
                <span style={styles.btnSendIcon}>→</span>
              </motion.button>
            </form>

            <div style={styles.divider}>
              <span style={styles.dividerLine} />
              <span style={styles.dividerText}>ou</span>
              <span style={styles.dividerLine} />
            </div>

            <motion.button
              type="button"
              onClick={() => setShowRdv(true)}
              style={styles.secondaryButton}
              whileHover={{ scale: 1.02, background: "rgba(255,255,255,0.1)" }}
              whileTap={{ scale: 0.98 }}
            >
              <span style={styles.rdvIcon}>📅</span>
              Prendre un rendez-vous — 30 min
            </motion.button>

            <AnimatePresence>
              {sent && (
                <motion.div
                  initial={{ opacity: 0, y: 10, scale: 0.96 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -10, scale: 0.96 }}
                  style={styles.success}
                >
                  <span style={styles.successIcon}>✓</span>
                  Message envoyé avec succès !
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </motion.div>
      </div>

      {/* === POPUP CALENDLY === */}
      <AnimatePresence>
        {showRdv && (
          <motion.div
            style={styles.modalOverlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowRdv(false)}
          >
            <motion.div
              style={styles.calendlyModal}
              initial={{ opacity: 0, y: 20, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.96 }}
              transition={{ duration: 0.25 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.calendlyHeader}>
                <div>
                  <h3 style={styles.calendlyTitle}>📅 Prendre rendez-vous</h3>
                  <p style={styles.calendlySubtitle}>
                    Sélectionnez un créneau disponible.
                  </p>
                </div>
                <button
                  onClick={() => setShowRdv(false)}
                  style={styles.calendlyClose}
                >
                  ✕
                </button>
              </div>
              <div style={styles.calendlyFrameWrapper}>
                <iframe
                  src="https://calendly.com/modyhady94/30min?hide_event_type_details=1&hide_gdpr_banner=1"
                  title="Calendly"
                  style={styles.calendlyIframe}
                  frameBorder="0"
                />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Keyframes injectés */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500;600;700&display=swap');

        @keyframes aurora1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(60px, -40px) scale(1.1); }
        }
        @keyframes aurora2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-50px, 50px) scale(1.08); }
        }
        @keyframes aurora3 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(30px, 30px) scale(1.05); }
        }
        .float-input-wrapper input:focus ~ label,
        .float-input-wrapper input:not(:placeholder-shown) ~ label,
        .float-input-wrapper textarea:focus ~ label,
        .float-input-wrapper textarea:not(:placeholder-shown) ~ label {
          top: 10px;
          font-size: 10px;
          color: rgba(139, 180, 255, 0.9);
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }
        .float-input-wrapper input:focus,
        .float-input-wrapper textarea:focus {
          border-color: rgba(99, 102, 241, 0.6) !important;
          box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12), 0 8px 24px rgba(0,0,0,0.2) !important;
        }
      `}</style>
    </div>
  );
}

/* === Composant FloatInput === */
function FloatInput({ name, label, type, value, onChange }) {
  return (
    <div className="float-input-wrapper" style={floatStyles.wrapper}>
      <input
        name={name}
        type={type}
        placeholder=" "
        value={value}
        onChange={onChange}
        required
        style={floatStyles.input}
      />
      <label style={floatStyles.label}>{label}</label>
    </div>
  );
}

function FloatTextarea({ name, label, value, onChange }) {
  return (
    <div className="float-input-wrapper" style={floatStyles.wrapper}>
      <textarea
        name={name}
        placeholder=" "
        value={value}
        onChange={onChange}
        rows="4"
        required
        style={{ ...floatStyles.input, resize: "none", paddingTop: "28px" }}
      />
      <label style={floatStyles.label}>{label}</label>
    </div>
  );
}

const floatStyles = {
  wrapper: {
    position: "relative",
    width: "100%",
  },
  input: {
    width: "100%",
    padding: "26px 16px 10px",
    borderRadius: "14px",
    fontSize: "14px",
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: "500",
    outline: "none",
    color: "#e8f0fe",
    background: "rgba(255,255,255,0.05)",
    border: "1.5px solid rgba(255,255,255,0.1)",
    boxSizing: "border-box",
    transition: "border-color 0.25s ease, box-shadow 0.25s ease",
    caretColor: "#818cf8",
  },
  label: {
    position: "absolute",
    left: "16px",
    top: "18px",
    fontSize: "14px",
    color: "rgba(255,255,255,0.4)",
    pointerEvents: "none",
    transition: "all 0.2s ease",
    fontFamily: "'DM Sans', sans-serif",
    fontWeight: "400",
  },
};

/* ================= STYLES PRINCIPAUX ================= */
const styles = {
  page: {
    position: "relative",
    minHeight: "100vh",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "80px 24px 60px",
    background: "#050b18",
    fontFamily: "'DM Sans', sans-serif",
  },

  /* === Fond aurora === */
  auroraLayer1: {
    position: "absolute",
    top: "-20%",
    left: "-10%",
    width: "700px",
    height: "700px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(67,56,202,0.35) 0%, transparent 70%)",
    filter: "blur(80px)",
    animation: "aurora1 18s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
  },
  auroraLayer2: {
    position: "absolute",
    bottom: "-15%",
    right: "-10%",
    width: "600px",
    height: "600px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(79,70,229,0.28) 0%, transparent 70%)",
    filter: "blur(70px)",
    animation: "aurora2 22s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
  },
  auroraLayer3: {
    position: "absolute",
    top: "40%",
    left: "40%",
    width: "500px",
    height: "500px",
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(16,185,129,0.12) 0%, transparent 70%)",
    filter: "blur(90px)",
    animation: "aurora3 15s ease-in-out infinite",
    pointerEvents: "none",
    zIndex: 0,
  },
  noiseOverlay: {
    position: "absolute",
    inset: 0,
    opacity: 0.03,
    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
    backgroundSize: "180px",
    pointerEvents: "none",
    zIndex: 1,
  },
  gridOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage: `linear-gradient(rgba(99,102,241,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(99,102,241,0.04) 1px, transparent 1px)`,
    backgroundSize: "60px 60px",
    pointerEvents: "none",
    zIndex: 1,
  },

  /* === Bouton retour === */
  backButton: {
    position: "fixed",
    top: "24px",
    left: "24px",
    zIndex: 50,
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 18px",
    borderRadius: "50px",
    cursor: "pointer",
    color: "rgba(255,255,255,0.75)",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    fontWeight: "600",
    fontSize: "13px",
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: "0.2px",
    transition: "all 0.25s ease",
  },
  backArrow: {
    fontSize: "16px",
    lineHeight: 1,
  },

  /* === Layout === */
  layout: {
    position: "relative",
    zIndex: 10,
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "48px",
    maxWidth: "1080px",
    width: "100%",
    alignItems: "center",
  },

  /* === Colonne gauche === */
  leftCol: {
    display: "flex",
    flexDirection: "column",
    gap: "0",
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "11px",
    fontWeight: "700",
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "rgba(139,180,255,0.8)",
    marginBottom: "20px",
  },
  eyebrowDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "#6366f1",
    boxShadow: "0 0 10px rgba(99,102,241,0.8)",
  },
  bigTitle: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: "clamp(40px, 5vw, 58px)",
    fontWeight: "400",
    lineHeight: "1.1",
    color: "#f0f4ff",
    margin: "0 0 20px",
    letterSpacing: "-1px",
  },
  bigTitleAccent: {
    fontStyle: "italic",
    background: "linear-gradient(135deg, #818cf8, #60a5fa)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  leftSubtitle: {
    fontSize: "15px",
    lineHeight: "1.65",
    color: "rgba(240,244,255,0.55)",
    marginBottom: "36px",
    maxWidth: "400px",
  },
  contactInfoList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  infoCard: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "14px 18px",
    borderRadius: "14px",
    background: "rgba(255,255,255,0.03)",
    border: "1px solid rgba(255,255,255,0.07)",
    backdropFilter: "blur(8px)",
  },
  infoIcon: {
    fontSize: "20px",
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(99,102,241,0.12)",
    borderRadius: "10px",
    flexShrink: 0,
  },
  infoLabel: {
    fontSize: "11px",
    fontWeight: "700",
    letterSpacing: "1px",
    textTransform: "uppercase",
    color: "rgba(139,180,255,0.6)",
    marginBottom: "2px",
  },
  infoValue: {
    fontSize: "14px",
    fontWeight: "500",
    color: "rgba(240,244,255,0.85)",
  },

  /* === Carte formulaire === */
  card: {
    position: "relative",
    borderRadius: "24px",
    background: "rgba(255,255,255,0.04)",
    backdropFilter: "blur(24px)",
    WebkitBackdropFilter: "blur(24px)",
    overflow: "hidden",
  },
  cardGlowBorder: {
    position: "absolute",
    inset: 0,
    borderRadius: "24px",
    padding: "1px",
    background: "linear-gradient(135deg, rgba(99,102,241,0.5), rgba(255,255,255,0.08) 50%, rgba(16,185,129,0.2))",
    WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
  },
  cardInner: {
    padding: "36px 32px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "28px",
  },
  cardIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, rgba(99,102,241,0.3), rgba(79,70,229,0.2))",
    border: "1px solid rgba(99,102,241,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "22px",
    flexShrink: 0,
  },
  cardTitle: {
    margin: "0 0 4px",
    fontSize: "18px",
    fontWeight: "700",
    color: "#f0f4ff",
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: "-0.3px",
  },
  cardSubtitle: {
    margin: 0,
    fontSize: "12px",
    color: "rgba(240,244,255,0.45)",
    fontWeight: "400",
  },

  /* === Formulaire === */
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  /* === Bouton principal === */
  primaryButton: {
    marginTop: "8px",
    width: "100%",
    padding: "15px 20px",
    borderRadius: "14px",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: "0.3px",
    color: "#ffffff",
    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%)",
    boxShadow: "0 12px 40px rgba(99,102,241,0.3), inset 0 1px 0 rgba(255,255,255,0.15)",
    transition: "all 0.25s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
  btnSendIcon: {
    fontSize: "18px",
    transition: "transform 0.25s ease",
  },

  /* === Divider === */
  divider: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    margin: "20px 0",
  },
  dividerLine: {
    flex: 1,
    height: "1px",
    background: "rgba(255,255,255,0.08)",
  },
  dividerText: {
    fontSize: "12px",
    color: "rgba(255,255,255,0.3)",
    fontWeight: "500",
  },

  /* === Bouton secondaire === */
  secondaryButton: {
    width: "100%",
    padding: "14px 20px",
    borderRadius: "14px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    fontFamily: "'DM Sans', sans-serif",
    color: "rgba(240,244,255,0.85)",
    background: "rgba(255,255,255,0.05)",
    border: "1.5px solid rgba(255,255,255,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    transition: "all 0.25s ease",
    letterSpacing: "0.1px",
  },
  rdvIcon: {
    fontSize: "16px",
  },

  /* === Succès === */
  success: {
    marginTop: "14px",
    padding: "13px 16px",
    borderRadius: "14px",
    background: "rgba(16,185,129,0.1)",
    border: "1px solid rgba(16,185,129,0.25)",
    color: "#6ee7b7",
    fontWeight: "600",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  successIcon: {
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    background: "rgba(16,185,129,0.2)",
    border: "1px solid rgba(16,185,129,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "800",
    flexShrink: 0,
  },

  /* === POPUP CALENDLY === */
  modalOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 999,
    background: "rgba(2, 6, 23, 0.75)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
  },
  calendlyModal: {
    width: "min(980px, 96vw)",
    height: "min(740px, 92vh)",
    background: "rgba(10,14,30,0.95)",
    border: "1px solid rgba(99,102,241,0.25)",
    backdropFilter: "blur(24px)",
    WebkitBackdropFilter: "blur(24px)",
    borderRadius: "24px",
    boxShadow: "0 50px 150px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.05)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  calendlyHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    padding: "18px 22px",
    borderBottom: "1px solid rgba(255,255,255,0.07)",
    color: "#f0f4ff",
  },
  calendlyTitle: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "700",
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: "-0.2px",
    color: "#f0f4ff",
  },
  calendlySubtitle: {
    margin: "4px 0 0",
    fontSize: "13px",
    color: "rgba(240,244,255,0.5)",
    fontFamily: "'DM Sans', sans-serif",
  },
  calendlyClose: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.05)",
    color: "rgba(240,244,255,0.7)",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
  calendlyFrameWrapper: {
    flex: 1,
    background: "transparent",
  },
  calendlyIframe: {
    width: "100%",
    height: "100%",
    border: "none",
  },
};

export default Contact;